import type {
  ForgotFormValues,
} from '~/schema/forgot-form-schema'
import {
  getForgotFormSchema,
} from '~/schema/forgot-form-schema'

export { getForgotFormSchema }
export type { ForgotFormValues }

export type PostForgotRequest = ForgotFormValues

const DEFAULT_INITIAL_VALUES: ForgotFormValues = {
  email: '',
}

export function getInitialDefaultValues({
  defaultInitialValues,
}: {
  defaultInitialValues?: Partial<ForgotFormValues>
}): Partial<ForgotFormValues> {
  return {
    ...DEFAULT_INITIAL_VALUES,
    ...defaultInitialValues,
  }
}
